import React from 'react'
import { Grid as BaseGrid, Hidden as BaseHidden, styled } from '@mui/material'
import { Close as BaseCloseIcon, Info as BaseInfoIcon, Search as BaseSearchIcon } from '@mui/icons-material'
import { Spinner, CheckBox as BaseCheckBox } from '@chilecompra/react-kit/components'

export const DesktopNavigation = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 120px;
  ${props => props.theme.breakpoints.down('lg')} {
    gap: 0;
  }
`

export const CheckBox = styled(BaseCheckBox)`
  .MuiCheckbox-root {
    margin: 0;
    padding: 0;
  }
  &.MuiFormControlLabel-root {
    margin: 0 8px 0 0;
  }
`

export const Title = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;

  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 22px;
    line-height: 26px;
    margin: 0;
    text-align: left;
  }
`

export const Image = styled('img')`
  margin-top: -80px;
  width: 120%;
`

export const Instructions = styled('div')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
  }
`

export const Form = styled('form')`
  width: 80%;
  ${props => props.theme.breakpoints.down('lg')} {
    margin-top: -15px;
    width: 100%;
  }
  label {
    color: ${props => props.theme.palette.brand.black1};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    text-align: left;
  }
`

export const Search = styled(({ clear, loading, ...props }) => <button {...props} />)`
  align-items: center;
  background-color: ${props => (props.clear ? props.theme.palette.brand.black3 : props.theme.palette.brand.primary)};
  border: 0;
  border-radius: 0;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 100%;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  outline: 0;
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  user-select: ${props => (props.disabled ? 'none' : 'initial')};
  width: 40px;

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${props => (props.clear ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
  }
`

export const SearchClearIcon = styled(BaseCloseIcon)`
  color: ${props => props.theme.palette.brand.white};
  height: 24px;
  width: 24px;
`

export const SearchIcon = styled(BaseSearchIcon)`
  color: ${props => props.theme.palette.brand.white};
  height: 24px;
  width: 24px;
`

export const SearchLoadingIcon = styled(props => <Spinner {...props} size="18px" />)`
  color: ${props => props.theme.palette.brand.white};
  & .MuiCircularProgress-root {
    color: ${props => props.theme.palette.brand.white};
  }
`
export const MobileNavigation = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  gap: 18px;
  flex-grow: 1;
  width: 90%;
`

export const Root = styled('div')`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};

  label {
    color: ${props => props.theme.palette.brand.black1};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    text-align: left;
  }
`

export const Hidden = styled(BaseHidden)``

export const ToastContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;

  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`

export const Divider = styled('div')`
  margin-bottom: 15px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand[props.color]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: ${props => (props.underline ? 'underline' : 'inherit')};

  &:hover {
    color: ${({ color, theme }) => {
      switch (color) {
        case 'primary':
          return theme.palette.blue[35]
        case 'black2':
          return theme.palette.brand.black3
        default:
          return 'inherit'
      }
    }};
  }
`
export const Strong = styled('b')`
  font-weight: 700;
`
